import { fetch } from '@utils/utils';

import * as T from '@modules/protocols/_protocolsTypes';

const getProtocol = ({ addError }) => async (id: string): Promise<T.Protocol> => {
  try {
    const response: any = await fetch(`/metropolis/api/wa/protocols/${id}`, {
      method: 'GET',
      headers: new Headers({ 'Content-Type': 'application/json' })
    });

    const json: T.Protocol = await response.json();

    return json;
  } catch (err) {
    addError(err.message);
    return {};
  }
};

const putProtocol = ({ addError, addSuccess }) => async (body: any): Promise<boolean> => {
  try {
    const response = await fetch(`/metropolis/api/wa/protocols/${body.id}`, {
      method: 'PUT',
      headers: new Headers({ 'Content-Type': 'application/json' }),
      body: JSON.stringify(body)
    });
    addSuccess('Úspěšne uloženo');

    return response.ok;
  } catch (err) {
    addError(err.message || 'Nastala chyba');

    return false;
  }
};

export { getProtocol, putProtocol };



// WEBPACK FOOTER //
// ./src/modules/protocols/_protocolsActions.ts